import {
  Component,
  OnInit,
  Input,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';

import {
  ClassicEditor,
  Bold,
  Essentials,
  Italic,
  Mention,
  Paragraph,
  Undo,
  CodeBlock,
  Code,
  FindAndReplace,
  Underline,
  PageBreak,
  RemoveFormat,
  BlockQuote,
  Table,
  Image,
  Font,
  Heading,
  Highlight,
  HorizontalLine,
  Superscript,
  Subscript,
  Link,
  MediaEmbed,
  Strikethrough,
  Alignment,
  ImageUpload,
  Indent,
  List,
  SpecialCharacters,
  SourceEditing,
  Base64UploadAdapter,
	CKFinder,
	CKFinderUploadAdapter,  
	ImageCaption,
	ImageStyle,
	ImageToolbar,		
} from 'ckeditor5';

@Component({
  selector: 'app-text',
  templateUrl: './text.component.html',
  styleUrls: ['./text.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class TextComponent implements OnInit {
  @ViewChild('ckEditor') ckEditor: any;
  @Input() component: any;
  public currentLanguage: string = '';

  public Editor = ClassicEditor;

  public editorConfig: any = {
    toolbar: [
      'bold',
      'italic',
      'strikethrough',
      'underline',
      'subscript',
      'alignment',
      '|',
      'removeFormat',
      'superscript',
      'fontSize',
      'fontColor',
      'fontBackgroundColor',
      '|',
      'bulletedList',
      'numberedList',
      'outdent',
      'indent',
      'blockQuote',
      '|',
      'findAndReplace',
      'undo',
      'redo',
      '|',
      'link',
      'insertTable',
      'mediaEmbed',
      'imageUpload',
      '|',
      'heading',
      'specialCharacters',
      '|',
      'highlight',
      'horizontalLine',
      'pageBreak',
      '|',
      'code',
      'codeBlock',
      'sourceEditing',
    ],
    height: '70vh',
    ckfinder: {
      uploadUrl: '',
      options: {
        resourceType: 'Images',
        browseUrl: '/ckfinder.html?type=Images',
      },
    },
    allowedContent: true, // Note: CKEditor 5 uses a different content filtering mechanism.
    removePlugins: ['Template', 'Save', 'Print', 'Preview', 'NewPage'],
    plugins: [
      Bold,
      Essentials,
      Italic,
      Mention,
      Paragraph,
      Undo,
      CodeBlock,
      Code,
      FindAndReplace,
      Underline,
      PageBreak,
      RemoveFormat,
      BlockQuote,
      Table,
      CKFinder,
      CKFinderUploadAdapter,
      Heading,
      Image,
      ImageCaption,
      ImageStyle,
      ImageToolbar,
      ImageUpload,
      Base64UploadAdapter,
      Font,
      Heading,
      Highlight,
      HorizontalLine,
      Superscript,
      Subscript,
      Link,
      MediaEmbed,
      Strikethrough,
      Alignment,      
      Indent,
      List,
      SpecialCharacters,
      SourceEditing,
    ],
    placeholder: 'Type the content here!',
  };

  constructor() {} // private translate: TranslateService, // private i18nService: I18nService,

  ngOnInit() {
    // this.currentLanguage = this.i18nService.language;
  }
}
